<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">Order</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Order ID</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.id">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Status</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.status">
          </div>
        </div>
        <div class="form-group col-6 mb-2" v-if="data.city != null">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">City</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.city.name">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Location</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.address">
          </div>
        </div>
        <div class="form-group col-6 mb-2" v-if="data.helper_sub_category != null">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Sub Category</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.helper_sub_category.name">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Date Scheduled</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.scheduled_at.format('DD MMMM YYYY')">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Time Scheduled</label>
            <input type="text" disabled class="form-control" id="form-reference_by" v-model="data.scheduled_at.format('HH:mm')+' - '+data.scheduled_at.clone().add(3,'hours').format('HH:mm')">
          </div>
        </div>
        <div class="form-group col-6 mb-2">
          <skeleton-box
            height="30px"
            width="100%"
            v-show="is_loading"/>
          <div v-show="!is_loading">
            <label for="#form-education" class="pl-0 m-0 d-flex align-items-center">Notes</label>
            <textarea disabled class="form-control" id="form-reference_by" v-model="data.notes"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'

export default {
  props: ['data', 'is_loading'],
  components:{
    'skeleton-box': SkeletonBox,
  }
}
</script>
